import { Component, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { Constants } from "../../../constants/constants";

@Component({
  selector: "adaa-info-bar",
  imports: [TranslatePipe],
  templateUrl: "./info-bar.html",
  styleUrl: "./info-bar.scss",
})
export class InfoBarComponent {
  value = input.required<string>();
  color = input.required<number>();
  label = input.required<string>();

  subLabel = input<string | undefined>(undefined);
  fontSize = input<string>("0.75rem");

  constants = Constants;
}
